import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import SelectDropDown from './SelectDropDown'
import RegistrationService from '../services/registration'
import InputField from './InputField'
import PrimaryGradientButton from './PrimaryGradientButton'
import DatePicker from './DatePicker'
import OtherService from '../services/Other'
import AlertMsg from './AlertMsg'
import { useNavigate } from 'react-router-dom'
import Loader from "./Loader";
import { addTotalCartItems } from '../redux/slices/countSlice'
import { useDispatch } from 'react-redux'

const BasicProfileComponent = () => {
    // Function to convert date to the standard format (YYYY-MM-DD)
    const dispatch = useDispatch();
    const isBasicProfileDone = JSON.parse(localStorage.getItem('isBasicProfileDone'));
    const formatDateYear = (date) => {
        const [day, month, year] = date.split('-');
        return `${year}-${month}-${day}`;
    };
    // Function to convert date to the standard format (DD-MM-YYYYs)
    function convertDateFormat(inputDate) {
        // Split the input date by '-'
        var parts = inputDate.split('-');
        
        // Rearrange the parts to form the desired format
        var outputDate = parts[2] + '-' + parts[1] + '-' + parts[0];
        
        return outputDate;
    }
    //Country
    const [isCountryList, setIsCountryList] = useState([])
    const [contentCountry, setContentCountry] = useState({ id: '', title: '' });
    //State
    const [isStateList, setIsStateList] = useState([])
    const [contentState, setContentState] = useState({ id: "", title: "" });
    //District
    const [isDistrictList, setIsDistrictList] = useState([])
    const [contentDistrict, setContentDistrict] = useState({ id: "", title: "" });
    //City
    const [isCityList, setIsCityList] = useState([])
    const [contentCity, setContentCity] = useState({ id: "", title: "" });
    //Taluka
    const [isTalukaList, setIsTalukaList] = useState([])
    const [contentTaluka, setContentTaluka] = useState({ id: "", title: "" });
    const [dealerTSE, setDealerTSE] = useState({ id: "", title: "" });
    //Marital Status
    const [maritalStatus, setMaritalStatus] = useState({ id: "", title: "" });
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(true);
    //Address Status
    const [address, setAddress] = useState(
        {

            line: '',
            spouse: '',
            spouseDOB: '',
            anniversaryDOB: '',
            dob: ''

        }
    )

    //Validation Error//
    const [isCountryValidationError, setIsCountryValidationError] = useState('');
    const [isStateValidationError, setIsStateValidationError] = useState('');
    const [isDistrictValidationError, setIsDistrictValidationError] = useState('');
    const [isCityValidationError, setIsCityValidationError] = useState('');
    const [isTalukaValidationError, setIsTalukaValidationError] = useState('');
    const [dealerTseValidationError, setDealerTseValidationError] = useState('');
    const [isMaritalStatusValidationError, setIsMaritalStatusValidationError] = useState('')
    const[isDOBValidationError,setIsDOBValidationError] = useState('')
    const [dealerTSEList, setDealerTSEList] = useState({ id: "", title: "" })
    const [canUpdate, setCanUpdate] = useState(true)
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const[contactId, setContactId] = useState('');
    const[brandId, setBrandId] = useState('');
    const[isAddressValidationError,setIsAddressValidationError] = useState('');
    const[isSpouseValidationError,setIsSpouseValidationError] = useState('');
    const[isSpouseDOBValidationError,setIsSpouseDOBValidationError] = useState('');
    const[isSpouseValidationAnniError,setIsSpouseValidationAnniError] = useState('');
    const[isTSEListValidationError,setIsTSEListValidationError] = useState('');
    const[isDealerListValidationError,setIsDealerListValidationError] = useState('');
    const navigate = useNavigate();
    //DealerTseList
    const [dealerOrTseList, setDealerOrTseList] = useState([])
    //Local Storage
    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('userData'));
        if(!userInfo) {
            localStorage.clear();
            window.location.reload();
            dispatch(addTotalCartItems({
                cartCount:0
            }))
            navigate('/');
        }
        const contactId = userInfo?.dcm_contacts_id;
        const brandId = userInfo?.dcm_brands_id;
        setContactId(contactId);
        setBrandId(brandId);
    }, [])
    //Basic Profile Info
    // useEffect(() => {
    //     const basicProfileInfo = async () => {
    //         try {
    //             const token = localStorage.getItem('access_token')
    //             const response = await RegistrationService.getBasicProfileInfo(token);

    //             if (response.success == true && response.response.canUpdate == 'false') {
    //                 setContentState({
    //                     id: response.response.basicProfileDetails.dcm_states_id,
    //                     title: response.response.basicProfileDetails.dcm_states_name
    //                 });
    //                 setContentDistrict({
    //                     id: response.response.basicProfileDetails.dcm_districts_id,
    //                     title: response.response.basicProfileDetails.dcm_district_name
    //                 })
    //                 setContentTaluka({
    //                     id: response.response.basicProfileDetails.dcm_taluka_id,
    //                     title: response.response.basicProfileDetails.dcm_taluka_name
    //                 })
    //                 setDealerTSE({
    //                     id: response.response.basicProfileDetails.select_TSE_or_Dealer,
    //                     title: response.response.basicProfileDetails.select_TSE_or_Dealer
    //                 })
    //                 setDealerTSEList({
    //                     id: response.response.basicProfileDetails.tse_id,
    //                     title: response.response.basicProfileDetails.tse_name
    //                 })
    //                 setAddress({
    //                     line: response.response.basicProfileDetails.line1 + " " + response.response.basicProfileDetails.line2 + " " + response.response.basicProfileDetails.line3,
    //                     spouse: response.response.basicProfileDetails.spouse_name,
    //                     dob: response.response.basicProfileDetails.date_of_birth,
    //                     spouseDOB: formatDateYear(response.response.basicProfileDetails.spouse_birthaDay),
    //                     anniversaryDOB: formatDateYear(response.response.basicProfileDetails.marraige_Anniversary)
    //                 })
    //                 setMaritalStatus({
    //                     id: response.response.basicProfileDetails.marital_status,
    //                     title: response.response.basicProfileDetails.marital_status
    //                 })
    //                 setCanUpdate(false)
    //                 setLoading(false)
    //             }

    //         }
    //         catch (e) {
    //         }

    //     }
    //     basicProfileInfo()
    // }, [])
    //All Countries
    useEffect(() => {
        const fetchCountryData = async () => {
            try {
                const response = await RegistrationService.allCountries();
                if (response.success == true && response.response.countriesDetails.length > 0) {
                    const countryNames = response.response.countriesDetails.filter(item =>
                        ['India'].includes(item.name),
                    ).map(country =>
                    (
                        {
                            id: country.id,
                            title: country.name
                        }
                    )
                    );
                    setContentCountry(countryNames[0])
                    setLoading(false)
                }

            }
            catch (error) {
                console.error('Error fetching country data:');
            }
        };
        fetchCountryData()
    }, [])
    //All States
    useEffect(() => {
        const stateListFetch = async () => {

            if (contentCountry.id) {
                try {
                    const stateListResponse = await RegistrationService.allStates(contentCountry.id);
                    if (stateListResponse.success == true && stateListResponse.response.statesDetails.length > 0) {
                        const statesDetails = stateListResponse.response.statesDetails;

                        setIsStateList(statesDetails.map((item) => ({
                            id: item.id,
                            title: item.name
                        })));
                        setLoading(false)
                    }

                } catch (error) {
                    console.error("Error");
                }
            };
        };

        stateListFetch();
    }, [contentCountry.id]);
    //All City
    useEffect(() => {
        const fetchCityList = async () => {
            if (contentCountry.id && contentState.id) {
                try {
                    const cityListResponse = await RegistrationService.allCities(contentCountry.id, contentState.id);
                    if (cityListResponse.success == true && cityListResponse.response.citiesDetails.length > 0) {
                        setIsCityList(cityListResponse.response.citiesDetails.map((item) =>
                        (
                            {
                                id: item.id,
                                title: item.name
                            }
                        )
                        ))
                        setLoading(false)
                    }
                }
                catch (error) {
                    console.error("Error")

                }
            }
        }
        fetchCityList()
    }, [contentCountry.id, contentState.id])
    //All District
    useEffect(() => {
        const fetchDistrictList = async () => {
            if (contentCountry.id && contentState.id) {
                try {
                    const token = localStorage.getItem('access_token')
                    const districtListResponse = await RegistrationService.allDistricts(contentCountry.id, contentState.id, token);
                    if (districtListResponse.success == true && districtListResponse.response.districtDetails.length > 0) {
                        setIsDistrictList(districtListResponse.response.districtDetails.map((item) =>
                        (
                            {
                                id: item.id,
                                title: item.name
                            }
                        )
                        
                        ))
                        
                    }

                }
                catch (error) {
                    console.error("Error")

                }
            }
        }
        fetchDistrictList()
    }, [contentCountry.id, contentState.id])
    //All Taluka
    useEffect(() => {
        const fetchTalukaList = async () => {
            if (contentDistrict.id) {
                try {
                    const token = localStorage.getItem('access_token')
                    const talukaListResponse = await RegistrationService.talukasByDistrict(contentDistrict.id, token);

                    if (talukaListResponse.success == true && talukaListResponse.response.talukaDetails.length > 0) {
                        setIsTalukaList(talukaListResponse.response.talukaDetails.map((item) =>
                        (
                            {
                                id: item.id,
                                title: item.name
                            }
                        )
                        ))
                        
                    }

                }
                catch (error) {
                    console.error("Error")

                }
            }
        }
        fetchTalukaList()
    }, [contentDistrict.id])
    const dealerOrTse = [
        {
            id: 'TSE',
            title: 'TSE',
        },
        {
            id: 'Dealer',
            title: 'Dealer',
        },
    ];
    const isMaritalList = [
        {
            id: 'Married',
            title: 'Married',
        },
        {
            id: 'Single',
            title: 'Single',
        },
    ]
    //Dealer/TSE List//
    useEffect(() => {
        const DealerTSEListFetch = async () => {
            try {
                const payload = {
                    userContactId: 0,
                  };
                const token = localStorage.getItem('access_token')
                const officerId = dealerTSE.id
                const districtId = contentDistrict.id
                const talukId = contentTaluka.id
                const userInfo = JSON.parse(localStorage.getItem('userData'));
                
                const brandId = userInfo.dcm_brands_id
                const DealerTSEListResponse = await RegistrationService.getDealersOrTse(officerId, districtId,talukId,brandId,payload,token)

                if (DealerTSEListResponse.success == true && DealerTSEListResponse.response.adminDetails.length > 0) {
                    setDealerOrTseList(DealerTSEListResponse.response.adminDetails.map((item, index) => {
                        return (
                            {
                                id: item?.id,
                                title: item?.full_name
                            }
                        )
                    }))
                    setLoading(false)
                }
            }
            catch (e) {
                console.error('DealerTSEListResponse Error');
            }
        }
        DealerTSEListFetch()
    }, [dealerTSE, contentDistrict, contentTaluka])

    const handleContentCountryNameChange = (selected) => {
        setContentCountry(selected)
    }
    const handleContentStateNameChange = (selected) => {
        setContentState(selected)
        setIsStateValidationError('')
    }
    const handleContentDistrictNameChange = (selected) => {
        setContentDistrict(selected)
        setIsDistrictValidationError('')
    }
    const handleContentCityNameChange = (selected) => {
        setContentCity(selected)
    }
    const handleContentTalukaNameChange = (selected) => {
        setContentTaluka(selected)
        setIsTalukaValidationError('')
    }
    const handleContentDealerOptionChoose = (selected) => {
        setDealerTSE(selected)
        setDealerTseValidationError('')
        
       
    }
    const handleMaritalStatusOptionChoose = (selected) => {
        setMaritalStatus(selected)
        setIsMaritalStatusValidationError('')
    }
    const handleContentDealerOptionListChoose = (selected) => {
        setDealerTSEList(selected)
        setIsDealerListValidationError('')
        setIsTSEListValidationError('')
    }
    const handleBasicRegistrationInput = (e) => {
        setAddress({ ...address, [e.target.name]: e.target.value })
        switch (e.target.name) {
                case 'line':
                setIsAddressValidationError('');
                break;
                case 'dob':
                setIsDOBValidationError('');
                break;
                case 'spouse':
                setIsSpouseValidationError('');
                break;
                case 'spouseDOB':
                setIsSpouseDOBValidationError('');
                break;
                case 'anniversaryDOB':
                setIsSpouseValidationAnniError('');
                break;
        }

    }
    const handleBasicRegistrationContrator = async () => {
        const validations = [
            { value: contentState.id, setter: setIsStateValidationError, message: 'State is required.' },
            { value: contentDistrict.id, setter: setIsDistrictValidationError, message: 'District is required.' },
            { value: contentTaluka.id, setter: setIsTalukaValidationError, message: 'Taluka is required' },
            { value: dealerTSE.id, setter: setDealerTseValidationError, message: 'Dealer or TSE is required' },
          // { value: dealerTSE.id == "TSE"  && dealerTSEList.id, setter: setIsTSEListValidationError, message: 'TSE is required' },
            { value: address.line, setter: setIsAddressValidationError, message: 'Address is required' },
            { value: address.dob, setter: setIsDOBValidationError, message: 'DOB is required' },
            { value: maritalStatus.id, setter: setIsMaritalStatusValidationError, message: 'Marital Status is required' },
        ];
        if (dealerTSE.id !== 'TSE') {
            validations.push(
                { value: dealerTSEList.id, setter: setIsDealerListValidationError, message: 'Dealer is required' },
                
            );

        }
        if (dealerTSE.id !== 'Dealer') {
            validations.push(
                { value: dealerTSEList.id, setter: setIsTSEListValidationError, message: 'TSE is required' },
                
            );

        }
        if (maritalStatus.id !== 'Single') {
            validations.push(
                { value: address.spouse, setter: setIsSpouseValidationError, message: 'Spouse is required' },
                { value: address.spouseDOB, setter: setIsSpouseDOBValidationError, message: 'Spouse DOB is required' },
                { value: address.anniversaryDOB, setter: setIsSpouseValidationAnniError, message: 'Date of Anniversary is required' }
            );
        }
        

        let isValid = true;
        validations.forEach(({ value, setter, message }) => {
            if (!value) {
               setter(message);
                isValid = false;
            }
            else {
                setter(''); // Clear the error message
            }
        });
        

        if(isValid)
        {
        let payload;
        if (dealerTSE.title == 'TSE') {
                payload = {
                select_TSE_or_dealer: dealerTSE.id,
                active_sites: '4',
                address: address.line,
                city_id: contentDistrict.id,
                taluka_id: contentTaluka.id,
                contact_id: contactId,
                country_id: contentCountry.id,
                state_id: contentState.id,
                tse_id: dealerTSEList.id,
                brand_id: brandId.toString(),
                marital_status: maritalStatus.title,
                spouse_name: address.spouse ? address.spouse : '',
                spouse_birthday: address.spouseDOB ? convertDateFormat(address.spouseDOB) : '',
                marraige_anniversary: address.anniversaryDOB ? convertDateFormat(address.anniversaryDOB) : '',
                date_of_birth: address.dob
            };
        }
        if (dealerTSE.title == 'Dealer') {
                payload = {
                select_TSE_or_dealer: dealerTSE.id,
                active_sites: '4',
                address: address.line,
                city_id: contentDistrict.id,
                taluka_id: contentTaluka.id,
                contact_id: contactId,
                country_id: contentCountry.id,
                state_id: contentState.id,
                dealer_arr: [dealerTSEList.id],
                brand_id: brandId.toString(),
                marital_status: maritalStatus.title,
                spouse_name: address.spouse ? address.spouse : '',
                spouse_birthday: address.spouseDOB ? convertDateFormat(address.spouseDOB) : '',
                marraige_anniversary: address.anniversaryDOB ? convertDateFormat(address.anniversaryDOB) : '',
                date_of_birth: address.dob
            };
        }

        try {
            
            const token = localStorage.getItem('access_token')
            setIsButtonLoading(true)
            const BasicRegistrationSubmit = await RegistrationService.basicProfile(payload,token) 
            setIsButtonLoading(false)
            if(BasicRegistrationSubmit.success == true)
            {
                setShowAlert(true)
                setIsLoginSuccess({ isLogin: true, text: 'The basic registration has been successfully submitted' })
                setTimeout(()=>{
                    navigate('/landing')
                },3000)
            }
            else {
                setShowAlert(true)
                setIsLoginSuccess({ isLogin: false, text: 'Sorry, your request has not been fulfilled' })
                }
        }
        catch (e) {

        }
    }
    }
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion pageTitle="Basic Registration" currentPageName="Basic Registration" />
            <section className='padTop50 basicRegistrationPg'>
                <Container>
                    <Row className='justify-content-center align-item-center h-100'>
                        <Col xs={12} >
                            <div className='userInfoBox'>
                                <div className='dashboard-title'>
                                    <h4>Basic Registration</h4>
                                </div>
                                <div className="dashboard-details">
                                    <Row>
                                        {/* <Col xs={12} lg={3}>
                                            <SelectDropDown
                                                page='searchFilter'
                                                labelName='Country'
                                                requiredStar="*"
                                                options={isCountryList}
                                                selectedValue={contentCountry}
                                                setSelectedValue={setContentCountry}
                                                onChange={handleContentCountryNameChange} />
                                            {isCountryValidationError && (
                                                <div className="error-message">{isCountryValidationError}</div>
                                            )}
                                        </Col> */}
                                         <Col xs={12} lg={3}>
                                            <DatePicker
                                                
                                                inputFieldLabel="DOB"
                                                requiredStar="*"
                                                name="dob"
                                                value={address.dob}
                                                onChange={handleBasicRegistrationInput}
                                                dobSelection

                                            />
                                            {isDOBValidationError && (
                                                    <div className="error-message">{isDOBValidationError}</div>
                                                )}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown
                                                
                                                page='searchFilter'
                                                labelName='State'
                                                requiredStar="*"
                                                options={isStateList}
                                                selectedValue={contentState}
                                                setSelectedValue={setContentState}
                                                onChange={handleContentStateNameChange} />

                                            {isStateValidationError && (
                                                <div className="error-message">{isStateValidationError}</div>
                                            )}

                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown
                                                
                                                page='searchFilter'
                                                labelName='District'
                                                requiredStar="*"
                                                options={isDistrictList}
                                                selectedValue={contentDistrict}
                                                setSelectedValue={setContentDistrict}
                                                onChange={handleContentDistrictNameChange} />
                                            {isDistrictValidationError && (
                                                <div className="error-message">{isDistrictValidationError}</div>
                                            )}
                                        </Col>
                                        {/* <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="City"
                                                requiredStar="*"
                                                options={isCityList}
                                                setSelectedValue={setContentCity}
                                                selectedValue={contentCity}
                                                onChange={handleContentCityNameChange} />
                                            {isCityValidationError && (
                                                <div className="error-message">{isCityValidationError}</div>
                                            )}
                                        </Col> */}
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="Taluka"
                                                
                                                requiredStar="*"
                                                options={isTalukaList}
                                                setSelectedValue={setContentTaluka}
                                                selectedValue={contentTaluka}
                                                onChange={handleContentTalukaNameChange} />
                                            {isTalukaValidationError && (
                                                <div className="error-message">{isTalukaValidationError}</div>
                                            )}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="Dealer or TSE"
                                               
                                                requiredStar="*"
                                                options={dealerOrTse}
                                                setSelectedValue={setDealerTSE}
                                                selectedValue={dealerTSE}
                                                onChange={handleContentDealerOptionChoose} />
                                            {dealerTseValidationError &&
                                                (
                                                    <div className="error-message">{dealerTseValidationError}</div>
                                                )}
                                        </Col>
                                        {dealerTSE.id == 'TSE' &&
                                            <Col xs={12} lg={3}>
                                                <SelectDropDown labelName="TSE"
                                                   
                                                    requiredStar="*"
                                                    options={dealerOrTseList}
                                                    setSelectedValue={setDealerTSEList}
                                                    selectedValue={dealerTSEList}
                                                    onChange={handleContentDealerOptionListChoose} />
                                            {isTSEListValidationError && (
                                                <div className="error-message">{isTSEListValidationError}</div>
                                            )}                    
                                            </Col>
                                            
                                        }
                                        
                                        {dealerTSE.id == 'Dealer' &&
                                            <Col xs={12} lg={3}>
                                                <SelectDropDown labelName="Dealer"
                                                    
                                                    requiredStar="*"
                                                    options={dealerOrTseList}
                                                    setSelectedValue={setDealerTSEList}
                                                    selectedValue={dealerTSEList}
                                                    onChange={handleContentDealerOptionListChoose} />
                                             {isDealerListValidationError && (
                                                <div className="error-message">{isDealerListValidationError}</div>
                                            )}
                                            </Col>
                                            
                                            }
                                            
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                
                                                inputFieldLabel="Address Line"
                                                requiredStar="*"
                                                name="line"
                                                value={address.line}
                                                onChange={handleBasicRegistrationInput}
                                            />
                                            {isAddressValidationError && (
                                                    <div className="error-message">{isAddressValidationError}</div>
                                                )}
                                        </Col>
                                       
                                        {/* <Col xs={12} lg={3}>
                                            <InputField
                                                editable={canUpdate? true : false}
                                                inputFieldLabel="Address Line2"
                                                requiredStar="*"
                                                name="line2"
                                                value={address.line2}
                                                onChange={handleBasicRegistrationInput}
                                            />
                                        </Col> */}
                                        {/* <Col xs={12} lg={3}>
                                            <InputField
                                                editable={canUpdate? true : false}
                                                inputFieldLabel="Address Line3"
                                                requiredStar="*"
                                                name="line3"
                                                value={address.line3}
                                                onChange={handleBasicRegistrationInput}
                                            />
                                        </Col> */}
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="Marital Status"
                                                
                                                requiredStar="*"
                                                options={isMaritalList}
                                                setSelectedValue={setMaritalStatus}
                                                selectedValue={maritalStatus}
                                                onChange={handleMaritalStatusOptionChoose} />
                                            {isMaritalStatusValidationError &&
                                                (
                                                    <div className="error-message">{isMaritalStatusValidationError}</div>
                                                )}
                                        </Col>
                                        {maritalStatus.id == 'Married' && (
                                            <>
                                                <Col xs={12} lg={3}>
                                                    <InputField
                                                        
                                                        inputFieldLabel="Spouse Name"
                                                        requiredStar="*"
                                                        name="spouse"
                                                        value={address.spouse}
                                                        onChange={handleBasicRegistrationInput}

                                                    />
                                                    {isSpouseValidationError && (
                                                    <div className="error-message">{isSpouseValidationError}</div>
                                                )}
                                                </Col>
                                                <Col xs={12} lg={3}>
                                                    <DatePicker
                                                        
                                                        inputFieldLabel="Spouse Date of Birth"
                                                        requiredStar="*"
                                                        name="spouseDOB"
                                                        value={address.spouseDOB}
                                                        onChange={handleBasicRegistrationInput}
                                                        dobSelection

                                                    />
                                                    {isSpouseDOBValidationError && (
                                                    <div className="error-message">{isSpouseDOBValidationError}</div>
                                                )}
                                                </Col>
                                                <Col xs={12} lg={3}>
                                                    <DatePicker
                                                        
                                                        inputFieldLabel="Date of Anniversary"
                                                        requiredStar="*"
                                                        name="anniversaryDOB"
                                                        value={address.anniversaryDOB}
                                                        onChange={handleBasicRegistrationInput}

                                                    />
                                                    {isSpouseValidationAnniError && (
                                                    <div className="error-message">{isSpouseValidationAnniError}</div>
                                                )}
                                                </Col>
                                            </>
                                        )}
                                        <Col xs={12} lg={3}>
                                            {
                                                canUpdate == true ?
                                                    (
                                                        <PrimaryGradientButton
                                                            buttonText={isButtonLoading ? "Processing..." : "Submit"}
                                                            className={maritalStatus.id == 'Married' ? "mt-4" : "mt-4"}
                                                            onClick={handleBasicRegistrationContrator}
                                                            disabled={isButtonLoading} />
                                                    )
                                                    : (
                                                        <PrimaryGradientButton
                                                            buttonText="Submit"
                                                            className={maritalStatus.id == 'Married' ? "mt-4" : "mt-28"}
                                                            disabled />
                                                    )

                                            }

                                        </Col>
                                        {showAlert &&
                                        <Col xs={12} lg={6} className='mt-3'>
                                           
                                                 <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                    heading={isLoginSuccess.heading}
                                                    text={isLoginSuccess.text}
                                                />
                                                
                                            
                                        </Col>
                                        }
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
export default BasicProfileComponent